import React, { useContext, useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { ApiCallGateway } from "../../Network/apiCallGateway";
import { DataContext } from "../../context/DataContext";
import PasswordHelper from "../PasswordHelper";
import { sharePWSchemaObj } from "../../Validation/PasswordValidation";
import { useFormik } from "formik";
import {
  validationSchema,
  getType,
  upperCase,
  lowerCase,
  numbers,
  symbols,
} from "../../Utils/CommonFunction";
import PasswordForm from "../../Components/Modal/PasswordForm";
import { sweetAlert } from "../../Utils/SweetAlert";
import NoData from "../../Components/NoData";
import Pagination from "../../Components/Pagination/Pagination";

function SharedPassword(props) {
  const {
    selectedUsers,
    adminViewUser,
    setBrudCrumb,
    setSidebarSelected,
  } = useContext(DataContext);

  const [shareePasswordPage, setsharePasswordPage] = useState(1);
  const [folderId, setFolderId] = useState("");
  const [shareModal, setShareModal] = useState(false);
  const [pwDetails, setpwDetails] = useState({});
  const [passwordId, setpasswordId] = useState("");
  const [passwordLength, setPasswordLength] = useState(8);
  const [uppercaseCheck, setUppercaseCheck] = useState(true);
  const [lowercaseCheck, setLowercaseCheck] = useState(true);
  const [numberCheck, setNumberCheck] = useState(true);
  const [symbolCheck, setSymbolCheck] = useState(true);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [generatePassVisible, setGeneratePassVisible] =
    useState(false);
  const [passwordType, setPasswordType] = useState("APIs");
  const [passwordModal, setPasswordModal] = useState(false);

  const sharetoggle = () => setShareModal(!shareModal);
  const toggleGeneratePass = () =>
    setGeneratePassVisible(!generatePassVisible);
  const togglePassword = () => setPasswordVisible(!passwordVisible);
  const passwordModeltoggle = () => setPasswordModal(!passwordModal);
  const {
    isLoading: passwordLoading,
    data: passwordList,
    refetch: passwordRefetch,
  } = useQuery({
    queryKey: ["sharePasswordList"],
    queryFn: async () => {
      const res = await ApiCallGateway.password.getAllSharePassword(
        shareePasswordPage,
        adminViewUser?._id || null
      );
      if (res?.status === 200) {
        return res?.data;
      } else {
        return [];
      }
    },
  });
  useEffect(() => {
    if (generatePassVisible)
      generatePassword(
        uppercaseCheck,
        lowercaseCheck,
        numberCheck,
        symbolCheck
      );
  }, [
    symbolCheck,
    uppercaseCheck,
    numberCheck,
    lowercaseCheck,
    passwordLength,
    generatePassVisible,
  ]);

  const isOpChecked = (param) => {
    let pw;
    if (param === "numbers") {
      pw = numbers();
      return { isChecked: numberCheck, pwGen: pw };
    }
    if (param === "upperCase") {
      pw = upperCase();
      return { isChecked: uppercaseCheck, pwGen: pw };
    }
    if (param === "symbols") {
      pw = symbols();
      return { isChecked: symbolCheck, pwGen: pw };
    }
    if (param === "lowerCase") {
      pw = lowerCase();
      return { isChecked: lowercaseCheck, pwGen: pw };
    }
  };

  async function generatePassword(
    uppercaseCheck,
    lowercaseCheck,
    numberCheck,
    symbolCheck
  ) {
    const symbols = symbolCheck ? 1 : 0;
    const numbers = numberCheck ? 1 : 0;
    const lowercase = lowercaseCheck ? 1 : 0;
    const uppercase = uppercaseCheck ? 1 : 0;
    if (numbers + symbols + uppercase + lowercase === 0) {
      return sweetAlert(
        "Oops!",
        "No box chosen. Please select at least one box!",
        "error"
      );
    }

    let pw = "";

    while (pw.length < passwordLength) {
      let num = Math.floor(Math.random() * getType.length);
      let typeAdder = getType[num];
      let status = isOpChecked(typeAdder);
      if (status?.isChecked) {
        pw += status?.pwGen;
      }
    }
    // setPassword(pw);
    passwordFormik.setFieldValue("password", pw);

    // onGeneratePw(pw);
  }
  useEffect(() => {
    passwordRefetch();
    setSidebarSelected("shared");
  }, [shareePasswordPage, adminViewUser]);
  // console.log(passwordList);

  const sharePasswordFormik = useFormik({
    initialValues: {
      passwordId: "",
      shareWith: [],
      expiryDate: "",
      permissionType: "View",
      note: "",
    },
    validationSchema: sharePWSchemaObj,
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      let data = [];
      // console.log({ ...values, shareWith: selectedUsers });
      for (const element of selectedUsers) {
        let a = {
          passwordId: values.passwordId,
          shareWith: element?._id,
          sharedEmail: element?.name,
          expiryDate: values.expiryDate ? values.expiryDate : null,
          permissionType: values.permissionType,
          note: values.note,
        };
        data.push(a);
      }
      // console.log(data, "kkk");
      const res = await ApiCallGateway.password.sharePassword(data);
      // console.log(res);
      sharetoggle();
      resetForm();
    },
  });
  const passwordFormik = useFormik({
    initialValues: validationSchema(passwordType, pwDetails, true)
      .initial,
    validationSchema: validationSchema(passwordType, pwDetails, true)
      .schma,
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      let res;

      if (
        values?.password === "XXXXXXXXXXXXX" ||
        values?.apiSecret === "XXXXXXXXXXXXX"
      ) {
        delete values?.apiSecret;
        delete values?.password;
      }
      // console.log(JSON.stringify(values), pwDetails);
      res = await ApiCallGateway.password.updatePassword(
        JSON.stringify(values),
        pwDetails?.passwordId
      );
      passwordModeltoggle();

      // console.log(res);
      passwordRefetch();
      resetForm();
    },
  });

  return (
    <div>
      <PasswordHelper
        passwordList={passwordList}
        viewType={props?.viewType}
        sharePasswordFormik={sharePasswordFormik}
        onRefetch={() => passwordRefetch()}
        isShared={true}
        passwordModeltoggle={() => passwordModeltoggle()}
        passweordDetails={(data) => {
          setpwDetails(data);
          setPasswordType(data?.passwordType);
        }}
        setEditPassword={() => {}}
        shareModal={shareModal}
      />
      <PasswordForm
        isEdit={true}
        passwordModaltoggle={() => passwordModeltoggle()}
        passwordModal={passwordModal}
        numberCheck={numberCheck}
        numberChecktoggle={() => setNumberCheck(!numberCheck)}
        uppercaseCheck={uppercaseCheck}
        uppercaseChecktoggle={() =>
          setUppercaseCheck(!uppercaseCheck)
        }
        lowercaseCheck={lowercaseCheck}
        lowercaseChecktoggle={() =>
          setLowercaseCheck(!lowercaseCheck)
        }
        symbolCheck={symbolCheck}
        symbolChecktoggle={() => setSymbolCheck(!symbolCheck)}
        passwordLength={passwordLength}
        setPasswordLength={(e) => setPasswordLength(e)}
        onRefresh={() =>
          generatePassword(
            uppercaseCheck,
            lowercaseCheck,
            numberCheck,
            symbolCheck
          )
        }
        passwordVisible={passwordVisible}
        togglePassword={() => togglePassword()}
        generatePassVisible={generatePassVisible}
        toggleGeneratePass={() => toggleGeneratePass()}
        // passwordValue={password}
        passwordType={passwordType}
        setPasswordType={(e) => setPasswordType(e)}
        formik={passwordFormik}
      />
      {passwordList?.data?.length < 1 ? <NoData /> : null}
      <Pagination
        totalPost={passwordList?.total}
        postsPerPage={passwordList?.limit}
        setCurrentPage={(e) => setsharePasswordPage(e)}
        currentPage={shareePasswordPage}
      />
    </div>
  );
}

export default SharedPassword;
